import * as React from "react";

export interface IOrderLog {
	time: string;
	sts: string;
}

export interface IObOrderLogProps {
	logs?: Array<IOrderLog>;
}

const ObOrderLog: React.FC<IObOrderLogProps> = (props) => {
	return (
		<div>
			<div className="order_log">
				<h4 className="ol_title">Order Log </h4>
				<ul className="ol_progress">
					{props.logs?.map((log, index) => (
						<li className="ol_progress bar" key={index}>
							{/* <p className="ol_time">{moment((dateTimeFormat(log.rcvEpTim))).format("D MMM 'YY | HH:mm:ss") }</p> */}
							<p className="ol_time">{log.time}</p>
							<h5 className="ol_info">{log.sts}</h5>
							<span className="circle"></span>
						</li>
					))}
				</ul>
			</div>
		</div>
	);
};

export default ObOrderLog;
